/*globals HelpHero */
import authAPI from "@/api/auth.js";
import userAPI from "@/api/user.js";
import partnerAPI from "@/api/partner.js";
import axios from 'axios';
export const auth = {
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: {},
    admin: false,
    superAdmin: false,
    partner: false,
    maxUsers: 0,
    level: 3,
    companyState: null,
    trialDays: 0,
    trialDaysRemaining: null,
    companyLogo: null,
    companyReferralCode:null,
    createCustomerPermission:null,
    partnerID:null,
    companyAvatar: null,
    teamManager:false,
    improveContent:false,
    partnerLevel1:false,
    bookDemo: false,
    partnerCompanyName: null,
    accountManager: false,
    invoicingAdmin: false,
    releaseUpdate: {},
    releaseDialog: true,
    seenCourseAlerts: {}
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token) {
      state.status = "success";
      state.token = token;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
      state.admin = false;
      state.superAdmin = false;
      state.partner = false;
      state.maxUsers = 0;
      state.level = 3;
      state.companyState = "";
      state.trialDays = 0;
      state.trialDaysRemaining = null;
      state.companyLogo = "";
      state.companyReferralCode = "";
      state.create_customer_permission = "";
      state.partnerID = "";
      state.companyAvatar = "";
      state.teamManager = false;
      state.improveContent = false;
      state.bookDemo = false;
      state.partnerLevel1 =false;
      state.accountManager = false;
      state.invoicingAdmin = false;
      state.releaseUpdate = {};
      state.releaseDialog = true;
    },
    setUser(state, user) {
      state.user = user;
    },
    setMaxUsers(state, maxUsers) {
      state.maxUsers = maxUsers;
    },
    setAdmin(state, bool) {
      state.admin = bool;
    },
    setSuperAdmin(state, bool) {
      state.superAdmin = bool;
    },
    setPartner(state, bool) {
      state.partner = bool;
    },
    setLevel(state, level) {
      state.level = level;
    },
    setCompanyState(state, companyState) {
      state.companyState = companyState;
    },
    setTrialDays(state, trialDays) {
      state.trialDays = trialDays;
    },
    // Numeric days left on a free trial (API trial_days_remaining: 0 = ends
    // today, negative = expired, null = not a trial). Read by TrialCountdown.
    setTrialDaysRemaining(state, days) {
      const n = Number(days);
      state.trialDaysRemaining = days === null || days === undefined || days === "" || isNaN(n) ? null : n;
    },
    setCompanyLogo(state, logo) {
      state.companyLogo = logo;
    },
    setCompanyReferralCode(state, code) {
      state.companyReferralCode = code;
    },
    setCreateCustomerPermission(state, permission) {
      state.createCustomerPermission = permission;
    },
    setPartnerID(state, partnerID) {
      state.partnerID = partnerID;
    },
    setCompanyAvatar(state, logo) {
      state.companyAvatar = logo;
    },
    setTeamManager(state, bool) {
      state.teamManager = bool;
    },
    setImproveContent(state, bool) {
      state.improveContent = bool;
    },
    setPartnerLevel1(state,bool){
      state.partnerLevel1 = bool;
    },
    setBookDemo(state, bool){
      state.bookDemo = bool;
    },
    setPartnerCompanyName(state, name){
      state.partnerCompanyName = name;
    },
    setAccountManager(state, bool) {
      state.accountManager = bool;
    },
    setInvoicingAdmin(state, bool){
      state.invoicingAdmin = bool;
    },
    setReleaseUpdate(state, releaseUpdate){
      state.releaseUpdate = releaseUpdate
    },
    setReleaseDialog(state, bool){
      state.releaseDialog = bool;
    },
    markCourseAlertsSeen(state, { userId, ids }){
      if (!userId) return;
      const existing = state.seenCourseAlerts[userId] || [];
      const merged = existing.slice();
      ids.forEach(id => { if (merged.indexOf(id) === -1) merged.push(id); });
      // Replace the object so vuex-persistedstate writes the change out.
      state.seenCourseAlerts = Object.assign({}, state.seenCourseAlerts, { [userId]: merged });
    }
  },
  actions: {
    login({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        localStorage.removeItem('disableNotify');
        authAPI.login(user)
          .then(resp => {
            const token = resp.data.access_token;
            localStorage.setItem("token", token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            // dispatch("profile");
            commit("auth_success", token);
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit, dispatch }) {
      return new Promise(resolve => {
        authAPI.logout();
        commit("logout");
        localStorage.removeItem("token");
        localStorage.removeItem('disableNotify');
        dispatch('theme/applyUserTheme', {primary: process.env.VUE_APP_PRIMARY_COLOR, secondary: "#000000", dark: false});
        delete axios.defaults.headers.common["Authorization"];
        if(localStorage.getItem('demoTooltipShown')){
          localStorage.removeItem("demoTooltipShown");
        }
        resolve();
      });
    },
    profile({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {

        userAPI.getProfile("?include=thumbnail,company")
          .then(resp => {
            commit("setUser", resp.data.data);

            if(process.env.VUE_APP_NAME == 'senso'){
            //add partner level 
            partnerAPI.getPartnerDetailByUserId(resp.data.data.id).then(resp => {
              this.partner = resp.data.data;
              //alert(this.partner.isPartnerLeve1);
              if(this.partner.isPartnerLeve1 == 1) {
                commit("setPartnerLevel1",true);
              } else {
                commit("setPartnerLevel1",false);
              }
            });
            //end
            }

            if(resp.data.data.release && state.releaseDialog){
                  commit('setReleaseUpdate', resp.data.data.release);
                  commit('setReleaseDialog',resp.data.data.release.show);
            }else{
              commit('setReleaseDialog', false);
            }
           
            // Defensive normalisation (2026-07-13): the `company` include can be absent
            // (null / deleted / orphan company) and company_avatar / banding_description can be
            // missing. Reading those unguarded below used to throw HERE, which rejected the
            // profile promise and left the user authenticated-but-stuck on the login screen
            // (getProfile's catch silently swallowed the error). Fall back to safe defaults so
            // the role switch never throws and the post-login redirect always runs.
            const _d = resp.data.data;
            const _companyData = (_d.company && _d.company.data) ? _d.company.data : {};
            const _companyAvatarUrl = (_d.company_avatar && _d.company_avatar.url) ? _d.company_avatar.url : "";
            const _defaultTheme = { primary: process.env.VUE_APP_PRIMARY_COLOR, secondary: "#000000", dark: false };
            const _themeColor = _companyData.theme_color ? _companyData.theme_color : _defaultTheme;
            // What the company may actually have, not what its banding says:
            // a free trial is capped at 5 people whatever band it sits on
            // (API user_allowance). Falls back to the banding maximum on an
            // older API, which is what this always used to read.
            const _bandingMax = (_companyData.user_allowance !== undefined && _companyData.user_allowance !== null)
              ? _companyData.user_allowance
              : ((_companyData.banding_description && _companyData.banding_description.max) ? _companyData.banding_description.max : "");

            switch (resp.data.data.role_id) {
              case 1:
                commit("setAdmin", false);
                commit("setSuperAdmin", true);
                commit("setPartner", false);
                commit("setTeamManager", false);
                commit("setLevel", 1);
                commit("setTrialDays",'');
                commit("setCompanyLogo","");
                commit("setCompanyAvatar","");
                commit("setImproveContent", false);
                commit("setInvoicingAdmin", false);
                break;

              case 2:
                commit("setAdmin", true);
                commit("setSuperAdmin", false);
                commit("setPartner", false);
                commit("setTeamManager", false);
                commit("setMaxUsers",_bandingMax)
                commit("setLevel", 2);
                commit("setCompanyState", _companyData.state);
                commit("setTrialDays", _companyData.trial_days_left);
                commit("setTrialDaysRemaining", _companyData.trial_days_remaining);
                commit("setCompanyLogo",_companyData.company_logo);
                commit("setCompanyAvatar",_companyAvatarUrl);
                commit("setPartnerID", resp.data.data.partner_id);
                commit("setImproveContent", resp.data.data.is_improve_edify_content);
                commit("setInvoicingAdmin", false);
                dispatch('theme/applyUserTheme', _themeColor);
                break;

              case 3:
                commit("setAdmin", false);
                commit("setSuperAdmin", false);
                commit("setPartner", false);
                commit("setTeamManager", false);
                commit("setLevel", 3);
                commit("setCompanyState", _companyData.state);
                commit("setTrialDays",'');
                commit("setCompanyLogo",_companyData.company_logo);
                commit("setCompanyAvatar",_companyAvatarUrl);
                commit("setPartnerID", resp.data.data.partner_id);
                commit("setImproveContent", false);
                commit("setInvoicingAdmin", false);
                dispatch('theme/applyUserTheme', _themeColor);
                break;

              case 4:
                commit("setAdmin", false);
                commit("setSuperAdmin", false);
                if(process.env.VUE_APP_NAME == 'direct'){
                  commit("setPartner", false);
                  commit("setTeamManager", true);
                  commit("setLevel", 7);
                  commit("setCompanyLogo",_companyData.company_logo);
                  commit("setCompanyAvatar",_companyAvatarUrl);
                  dispatch('theme/applyUserTheme', _themeColor);
                }else{  
                  commit("setPartner", true);
                  commit("setTeamManager", false);
                  commit("setLevel", 4);
                  commit("setCompanyLogo","");
                  commit("setCompanyAvatar","");
                  commit("setPartnerCompanyName",resp.data.data.partner_company_name);
                  dispatch('theme/applyUserTheme', _themeColor);
                }  
                // commit("setLevel", 4);
                commit("setTrialDays",'');
                commit("setCompanyReferralCode",resp.data.data.referral_code);
                commit("setImproveContent", false);
                commit("setCompanyState", _companyData.state);
                commit("setInvoicingAdmin", false);
                break;

              case 5:
                if(process.env.VUE_APP_NAME == 'direct'){
                commit("setAdmin", false);
                commit("setSuperAdmin", false);
                commit("setPartner", false);
                commit("setTeamManager", false);
                commit("setLevel", 8);
                commit("setTrialDays",'');
                commit("setCompanyLogo","");
                commit("setCompanyAvatar","");
                commit("setImproveContent", false);
                commit("setInvoicingAdmin", true);
                }else{
                commit("setAdmin", false);
                commit("setSuperAdmin", false);
                commit("setPartner", false);
                commit("setTeamManager", false);
                commit("setLevel", 5);
                commit("setCompanyState", _companyData.state);
                commit("setTrialDays",'');
                commit("setCompanyLogo","");
                commit("setCreateCustomerPermission",resp.data.data.create_customer_permission);
                commit("setPartnerID", resp.data.data.partner_id);
                commit("setCompanyAvatar","");
                commit("setImproveContent", false);
                commit("setAccountManager", true);
                commit("setInvoicingAdmin", false);
                }
                break;

              case 6:
                commit("setAdmin", false);
                commit("setSuperAdmin", false);
                commit("setPartner", false);
                commit("setTeamManager", false);
                commit("setLevel", 6);
                commit("setTrialDays",'');
                commit("setCompanyLogo","");
                commit("setCompanyAvatar","");
                commit("setImproveContent", false);
                commit("setInvoicingAdmin", false);
                break;

              case 7:
                commit("setAdmin", false);
                commit("setSuperAdmin", false);
                commit("setPartner", false);
                commit("setTeamManager", true);
                commit("setLevel", 7);
                commit("setTrialDays",'');
                commit("setCompanyLogo",_companyData.company_logo);
                commit("setCompanyAvatar",_companyAvatarUrl);
                commit("setImproveContent", false);
                commit("setCompanyState", _companyData.state);
                commit("setInvoicingAdmin", false);
                dispatch('theme/applyUserTheme', _themeColor);
                break;
              
              case 8:
                commit("setAdmin", false);
                commit("setSuperAdmin", false);
                commit("setPartner", false);
                commit("setTeamManager", false);
                commit("setLevel", 8);
                commit("setTrialDays",'');
                commit("setCompanyLogo","");
                commit("setCompanyAvatar","");
                commit("setImproveContent", false);
                commit("setInvoicingAdmin", true);
                dispatch('theme/applyUserTheme', _themeColor);
                break;


              default:
                dispatch("logout");
                break;
            }
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    autologin({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        authAPI.autologin(user)
            .then(resp => {
              const token = resp.data.access_token;
              localStorage.setItem("token", token);
              axios.defaults.headers.common["Authorization"] = "Bearer " + token;
              dispatch("profile");
              commit("auth_success", token);
              resolve(resp);
            })
            .catch(err => {
              commit("auth_error");
              localStorage.removeItem("token");
              reject(err);
            });
      });
    },
    loginWithSSO({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        localStorage.removeItem('disableNotify');
        authAPI.authenticateSSO(user)
          .then(resp => {
            resp = JSON.parse(resp.data);
            const token = resp.access_token;
            localStorage.setItem("token", token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + token;
            commit("auth_success", token);
            resolve(resp);
          })
          .catch(err => {
            // commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    admin: state => state.admin,
    user: state => state.user,
    superAdmin: state => state.superAdmin,
    partner: state => state.partner,
    maxUsers: state => state.maxUsers,
    level: state => state.level,
    companyState: state => state.companyState,
    trialDays: state => state.trialDays,
    trialDaysRemaining: state => state.trialDaysRemaining,
    // The unpaid bank transfer invoice of a trial that has bought IMPROVE
    // (API pending_invoice, 10 Oct 2026): { url, due_at }, or null.
    pendingInvoice: state => {
      const company = state.user && state.user.company && state.user.company.data;
      return (company && company.pending_invoice) || null;
    },
    companyLogo: state => state.companyLogo,
    companyReferralCode: state => state.companyReferralCode,
    create_customer_permission: state => state.createCustomerPermission,
    partnerID: state => state.partnerID,
    companyAvatar: state => state.companyAvatar,
    teamManager: state => state.teamManager,
    improveContent: state => state.improveContent,
    partnerLevel1: state => state.partnerLevel1,
    bookDemo: state => state.bookDemo,
    partnerCompanyName: state => state.partnerCompanyName,
    accountManager: state => state.accountManager,
    invoicingAdmin: state => state.invoicingAdmin,
    releaseUpdate: state => state.releaseUpdate,
    releaseDialog: state => state.releaseDialog,
    seenCourseAlerts: state => state.seenCourseAlerts || {},
  }
};
